import { ordersApi } from '../services/ordersApi';

export const myOrdersQueryKey = (token: string | null) => ['myOrders', token ?? ''] as const;

export function myOrdersQueryOptions(token: string | null) {
  return {
    queryKey: myOrdersQueryKey(token),
    queryFn: () => ordersApi.getMyOrders(token!),
    enabled: !!token,
    staleTime: 30_000,
  };
}

export function myOrderStatusQueryKey(token: string | null, orderRef: string | undefined) {
  return ['myOrderStatus', token ?? '', orderRef ?? ''] as const;
}
